import { FormattedMessage } from 'react-intl'

import TruckIcon from 'app/assets/icons/shipping/truck.svg'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import { ShippingScopeAvailability } from '../../helpers/shippingReturnRules.helpers'

interface ShippingScopeHeaderProps {
  shippingScope: ShippingScopeAvailability
  country?: string
}

const ShippingScopeHeader: RFC<ShippingScopeHeaderProps> = ({
  shippingScope,
  country
}) => {
  if (!shippingScope || !country) return null

  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
      <TruckIcon />

      <Text variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
        {shippingScope === 'international_only' && (
          <FormattedMessage
            defaultMessage="Ships internationally from {country}"
            values={{ country }}
          />
        )}

        {shippingScope === 'domestic_only' && (
          <FormattedMessage
            defaultMessage="Ships within {country} only"
            values={{ country }}
          />
        )}

        {shippingScope === 'both' && (
          <FormattedMessage
            defaultMessage="Ships within {country} and internationally"
            values={{ country }}
          />
        )}
      </Text>
    </Stack>
  )
}

export default ShippingScopeHeader
